import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { Clipboard } from '@capacitor/clipboard';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import { MiscService } from 'src/app/services/misc.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { WalletStore } from 'src/app/stores/wallet.store';

@Component({
  selector: 'app-process-screen',
  templateUrl: './process-screen.component.html',
  styleUrls: ['./process-screen.component.scss'],
})
export class ProcessScreenComponent implements OnInit {
  @Input() type: number = null;
  @Input() checkPayment: boolean = false;
  @Input() orderId: number = null;
  @Input() referenceId: number = null;
  @Input() paymentRef: number = null;
  @Input() paymentEntity: number = null;
  @Input() amount: number = null;

  interval = null;
  seconds: number = 200;
  paymentStatus = null;
  constructor(
    private modalCtrl: ModalController,
    private walletStore: WalletStore,
    private router: Router,
    private loaderService: LoaderService,
    private translate: TranslateService,
    private auth: AuthenticationStore,
    private navCtrl: NavController,
    public platform: Platform,
    private misc: MiscService
  ) {}

  ngOnInit() {}

  ionViewWillEnter() {
    this.startTimer();
  }

  async checkPaymentSuccess() {
    if (this.orderId) {
      var resp = await this.walletStore.checkPayment(this.orderId);
      this.paymentStatus = resp.data[0].payment_status;
      if (this.paymentStatus == 1) {
        this.loaderService.presentToast(
          this.translate.instant('FINANCE.PAYMENT_SUCCESS'),
          'middle',
          'success'
        );
        this.dismissModal();
        this.router.navigate(['/my-product-bag/payment-status']);
        this.clearInterval();
      } else if (this.paymentStatus == 2) {
        this.loaderService.presentToast(
          this.translate.instant('FINANCE.PAYMENT_FAILED'),
          'middle',
          'danger'
        );
        this.clearInterval();
        this.dismissModal();
        this.router.navigate(['/my-product-bag'], { replaceUrl: true });
      }
    } else if (this.referenceId) {
      var response = await this.walletStore.walletPayment(this.referenceId);
      this.paymentStatus = response.data.payment_status;
      if (this.paymentStatus == 1) {
        Browser.close();
        this.loaderService.presentToast(
          this.translate.instant('FINANCE.PAYMENT_SUCCESS'),
          'middle',
          'success'
        );
        this.dismissModal();
        this.clearInterval();
        this.navCtrl.back();
        this.auth.tokenVerify();
      } else if (this.paymentStatus == 2) {
        this.loaderService.presentToast(
          this.translate.instant('FINANCE.PAYMENT_FAILED'),
          'middle',
          'danger'
        );
        this.clearInterval();
        this.dismissModal();
      }
    }
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
    this.clearInterval();
  }

  startTimer() {
    this.interval = setInterval(
      function () {
        //if payment goes in process
        this.seconds = this.seconds - 5;
        if (this.orderId) {
          this.checkPaymentSuccess();
          if (this.paymentStatus == 1) {
            this.clearInterval();
          }
        }
        if (this.referenceId) {
          this.checkPaymentSuccess();
          if (this.paymentStatus == 1) {
            this.clearInterval();
          }
        }
        if (this.seconds == 0 && this.paymentStatus == 0) {
          this.loaderService.presentToast(
            this.translate.instant('FINANCE.PAYMENT_IN_PROCESS'),
            'middle',
            'danger'
          );
          this.clearInterval();
          this.dismissModal();
        }
      }.bind(this),
      5000
    );
  }

  clearInterval() {
    clearInterval(this.interval);
  }

  async writeToClipboard(paymentRef, type) {
    try {
      await Clipboard.write({
        string: paymentRef,
      });
      this.loaderService.presentToast(
        type == 1 ? this.translate.instant('PLACEHOLDER_TEXT.REF_COPY') : this.translate.instant('PLACEHOLDER_TEXT.ENTITY_COPY'),
        'bottom',
        'success'
      );
    } catch (error) {}
  }
}
